import React from "react";
import { HiTrophy, HiUserGroup, HiBeaker } from "react-icons/hi2";
import { HiCheck } from "react-icons/hi";
import { PerformanceType } from "../../../types/post";

const INTENTS: {
  type: PerformanceType;
  title: string;
  description: string;
  icon: React.ReactNode;
}[] = [
  {
    type: "competition",
    title: "Competition",
    description: "Athletics, swimming, running, meets",
    icon: <HiTrophy />,
  },
  {
    type: "gameDay",
    title: "Game Day",
    description: "Ball and team sports",
    icon: <HiUserGroup />,
  },
  {
    type: "testing",
    title: "Testing",
    description: "Time trial, benchmark or measured session",
    icon: <HiBeaker />,
  },
];

/** Step 1 — pick the intent. Styled like the Add Log picker rows. */
const IntentStep: React.FC<{
  value: PerformanceType | null;
  onSelect: (type: PerformanceType) => void;
}> = ({ value, onSelect }) => (
  <div className="space-y-3">
    <div className="space-y-2">
      {INTENTS.map((intent) => {
        const selected = value === intent.type;
        return (
          <button
            key={intent.type}
            type="button"
            onClick={() => onSelect(intent.type)}
            aria-pressed={selected}
            className={`w-full flex items-center gap-4 p-4 rounded-xl border text-left transition-colors ${
              selected
                ? "border-base-content bg-base-content/5"
                : "border-base-300 bg-base-100 hover:border-base-content/40"
            }`}
          >
            <span
              className={`w-10 h-10 rounded-full flex items-center justify-center text-xl flex-shrink-0 ${
                selected
                  ? "bg-base-content text-base-100"
                  : "bg-base-200 text-base-content/70"
              }`}
            >
              {intent.icon}
            </span>
            <span className="flex-1 min-w-0">
              <span className="block font-semibold font-grotesk text-base-content">
                {intent.title}
              </span>
              <span className="block text-sm text-base-content/60 font-grotesk">
                {intent.description}
              </span>
            </span>
            {selected && <HiCheck className="w-5 h-5 text-base-content flex-shrink-0" />}
          </button>
        );
      })}
    </div>
  </div>
);

export default IntentStep;
